import {
  BlockIcon,
  MarketplaceIcon,
  ManageAppsIcon,
  SettingsIcon,
  SystemIcon,
  UserGroupIcon,
  UserIcon,
} from "@components/icons";
import "./left-menu.scss";
import { NavLink } from "react-router-dom";
import { memo } from "react";
import { CustomTooltip } from "@components/tool-tip";
import { Permission } from "@contexts/permissions.context";
import { PermissionTypes } from "@archetypes/gql";

const LeftMenuComponent = () => {
  return (
    <>
      <div className="left-menu">
        <ul className="menu-items">
          <Permission access={[PermissionTypes.APP_READ]}>
            <li>
              <NavLink to="/builder/apps">
                <CustomTooltip content="Manage Apps" direction="right">
                  <ManageAppsIcon />
                </CustomTooltip>
              </NavLink>
            </li>
          </Permission>
          <Permission access={[PermissionTypes.CATEGORY_READ]}>
            <li>
              <NavLink to="/builder/categories">
                <CustomTooltip content="Manage Categories" direction="right">
                  <BlockIcon />
                </CustomTooltip>
              </NavLink>
            </li>
          </Permission>
          <Permission access={[PermissionTypes.USER_READ]}>
            <li>
              <NavLink to="/builder/users">
                <CustomTooltip content="Manage Users" direction="right">
                  <UserIcon color="#00033e" />
                </CustomTooltip>
              </NavLink>
            </li>
          </Permission>
          <Permission access={[PermissionTypes.GROUP_READ]}>
            <li>
              <NavLink to="/builder/groups">
                <CustomTooltip content="Manage Groups" direction="right">
                  <UserGroupIcon color="#00033e" />
                </CustomTooltip>
              </NavLink>
            </li>
          </Permission>
          <Permission access={[PermissionTypes.MARKETPLACE_READ]}>
            <li>
              <NavLink to="/builder/market-place">
                <CustomTooltip content="Marketplace" direction="right">
                  <MarketplaceIcon color="#00033e" />
                </CustomTooltip>
              </NavLink>
            </li>
          </Permission>
          <Permission access={[PermissionTypes.ENTITY_READ]}>
            <li>
              <NavLink to="/builder/entities" className="entity">
                <CustomTooltip content="Manage Entities" direction="right">
                  <SystemIcon />
                </CustomTooltip>
              </NavLink>
            </li>
          </Permission>
          <li>
            <NavLink to="/builder/settings/profile">
              <CustomTooltip content="Settings" direction="right">
                <SettingsIcon />
              </CustomTooltip>
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
};

export const LeftMenu = memo(LeftMenuComponent);
